export default __webpack_public_path__ + "static/media/Logoutbox.89464e92.svg";